import { useStyletron } from "baseui";
import * as React from "react";

export const EmbeddedVideo = ({ url, aspectRatio = "16 / 9" }: { url: string; aspectRatio?: string }) => {
  const [css] = useStyletron();

  return (
    <iframe
      className={css({
        aspectRatio,
        width: "100%",
      })}
      src={url}
      frameBorder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    />
  );
};
